import React, { Component } from 'react';
import classNames from 'classnames';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { AppTopbar } from '../../AppTopbar';
import { AppFooter } from '../../AppFooter';
import { AppMenu } from '../../AppMenu';
import { AppProfile } from '../../AppProfile';
import { Route } from 'react-router-dom';
import { AdministracionTrabajadores } from './AdministracionTrabajadores'
import { RecibosNomina } from "../app/RecibosNomina";
import { SubirXmlNomina } from "./SubirXmlNomina";
import { ReportesDif } from './ReportesDif';
import { Message } from 'primereact/message';
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';
import '../../layout/layout.scss';
import '../../App.scss';
import '../../App.css';

import { Dialog } from 'primereact/dialog';

import servicioHttp from "../../servicio/ServicioHttp";
import servicioObjetos from '../../servicio/ServicioObjetos';


class App extends Component {

    constructor() {
        super();
        this.state = {
            layoutMode: 'static',
            layoutColorMode: 'dark',
            staticMenuInactive: false,
            overlayMenuActive: false,
            mobileMenuActive: false,
            modalCorreo: false,
            usuario: {},
            errores: {}
        };

        this.onWrapperClick = this.onWrapperClick.bind(this);
        this.onToggleMenu = this.onToggleMenu.bind(this);
        this.onSidebarClick = this.onSidebarClick.bind(this);
        this.onMenuItemClick = this.onMenuItemClick.bind(this);
        this.createMenu();
        this.validarCorreo();
    }

    validarCorreo = () => {
        servicioHttp.consumirPostHttp('/usuario/consulta/validacion_correo.json', null).then(response => {
            if (response.data.error)
                this.setState({ modalCorreo: true });
        })
    }

    onWrapperClick(event) {
        if (!this.menuClick) {
            this.setState({
                overlayMenuActive: false,
                mobileMenuActive: false
            });
        }

        this.menuClick = false;
    }

    onToggleMenu(event) {
        this.menuClick = true;

        if (this.isDesktop()) {
            if (this.state.layoutMode === 'overlay') {
                this.setState({
                    overlayMenuActive: !this.state.overlayMenuActive
                });
            }
            else if (this.state.layoutMode === 'static') {
                this.setState({
                    staticMenuInactive: !this.state.staticMenuInactive
                });
            }
        }
        else {
            const mobileMenuActive = this.state.mobileMenuActive;
            this.setState({
                mobileMenuActive: !mobileMenuActive
            });
        }

        event.preventDefault();
    }

    onSidebarClick(event) {
        this.menuClick = true;
    }

    onMenuItemClick(event) {
        if (!event.item.items) {
            this.setState({
                overlayMenuActive: false,
                mobileMenuActive: false
            })
        }
    }

    createMenu() {
        servicioHttp.consumirPostHttp('/accion/menu.json', null).then(response => {
            this.menu = response.data.lista;
            this.setState(this.menu);
        }).catch(error => {

        });
    }

    addClass(element, className) {
        if (element.classList)
            element.classList.add(className);
        else
            element.className += ' ' + className;
    }

    removeClass(element, className) {
        if (element.classList)
            element.classList.remove(className);
        else
            element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }

    isDesktop() {
        return window.innerWidth > 1024;
    }

    componentDidUpdate() {
        if (this.state.mobileMenuActive)
            this.addClass(document.body, 'body-overflow-hidden');
        else
            this.removeClass(document.body, 'body-overflow-hidden');
    }


    agregarCorreo = () => {
        let { usuario } = this.state;
        let validacion = this.validarForm(usuario);
        this.setState({ errores: validacion });
        if (servicioObjetos.esObjetoVacio(validacion)) {
            servicioHttp.consumirPostHttp('/usuario/consulta/agregar_correo.json', { correo: usuario.correo }).then(response => {
                this.setState({ modalCorreo: false });
            }).catch(error => {

            });
        }

    }

    validarForm = (valor) => {
        const errores = {};
        if (servicioObjetos.esObjetoVacio(valor.correo))
            errores.correo = "El correo es requerido";
        return errores;
    }

    salirApp = () => {
        this.props.history.push("/dif");
    }

    cerrarModal=()=>{
        this.setState({modalCorreo:false});
    }

    asignarValores = (event) => {
        servicioObjetos.asignarAtributosObjeto(event, this, false);
    };

    render() {
        let { usuario, errores } = this.state;
        const wrapperClass = classNames('layout-wrapper', {
            'layout-overlay': this.state.layoutMode === 'overlay',
            'layout-static': this.state.layoutMode === 'static',
            'layout-static-sidebar-inactive': this.state.staticMenuInactive && this.state.layoutMode === 'static',
            'layout-overlay-sidebar-active': this.state.overlayMenuActive && this.state.layoutMode === 'overlay',
            'layout-mobile-sidebar-active': this.state.mobileMenuActive
        });

        const sidebarClassName = classNames("layout-sidebar", {
            'layout-sidebar-dark': this.state.layoutColorMode === 'dark',
            'layout-sidebar-light': this.state.layoutColorMode === 'light'
        });


        const footer = (
            <div>
                <Button label="Agregar Correo Electrónico" icon="pi pi-check" onClick={this.agregarCorreo} />
                <Button label="Salir" icon="pi pi-times" className="p-button-danger" onClick={this.salirApp} />
            </div>
        );

        const myIcon = (

            <span className="pi pi-envelope"></span>

        )

        return (
            <div className={wrapperClass} onClick={this.onWrapperClick}>
                <AppTopbar onToggleMenu={this.onToggleMenu} />

                <div ref={(el) => this.sidebar = el} className={sidebarClassName} onClick={this.onSidebarClick}>
                    <AppProfile />
                    <AppMenu model={this.menu} onMenuItemClick={this.onMenuItemClick} />
                </div>

                <div className="layout-main">
                    <Route path="/dif/bienvenido/trabajador" component={AdministracionTrabajadores} />
                    <Route path="/dif/bienvenido/nomina" exact component={RecibosNomina} />
                    <Route path="/dif/bienvenido/subir" component={SubirXmlNomina} />
                    <Route path="/dif/bienvenido/reportes" component={ReportesDif} />
                </div>

                <AppFooter />

                <div className="layout-mask"></div>

                <Dialog header="Aviso" footer={footer} iconsTemplate={myIcon} visible={this.state.modalCorreo} modal={true}
                    closeOnEscape={false} dismissableMask={false} closable={false} onHide={this.cerrarModal}>
                    <h3>Estimado buen día, puedes ser tan amable de agrega tu correo electrónico para poder recuperar tu contraseña, en un futuro.</h3>
                    <div className="p-fluid p-formgrid p-grid">
                        <div className="p-field p-col-12 p-md-12">
                            <label htmlFor="correo">Correo</label>
                            <InputText id="correo" type="text" name="usuario.correo" value={usuario.correo || ""} onChange={this.asignarValores} className={errores.usuario ? 'p-inputtext p-component' : 'p-inputtext p-component'} />
                            {errores.correo ? <div><Message severity="error" text={errores.correo} /> </div> : null}
                        </div>

                    </div>
                </Dialog>
            </div>
        );
    }
}

export default App;
